var BlockCopyPasteDirective = /** @class */ (function () {
    function BlockCopyPasteDirective() {
        this.allowBlock = false;
    }
    BlockCopyPasteDirective.prototype.blockPaste = function (e) {
        if (this.allowBlock) {
            e.preventDefault();
        }
    };
    BlockCopyPasteDirective.prototype.blockCopy = function (e) {
        if (this.allowBlock) {
            e.preventDefault();
        }
    };
    BlockCopyPasteDirective.prototype.blockCut = function (e) {
        if (this.allowBlock) {
            e.preventDefault();
        }
    };
    return BlockCopyPasteDirective;
}());
export { BlockCopyPasteDirective };
